import { render, staticRenderFns } from "./LimitlessPageTopNotificationsDropdown.vue?vue&type=template&id=172bf818&"
import script from "./LimitlessPageTopNotificationsDropdown.vue?vue&type=script&lang=js&"
export * from "./LimitlessPageTopNotificationsDropdown.vue?vue&type=script&lang=js&"
import style0 from "./LimitlessPageTopNotificationsDropdown.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports